module.exports = __webpack_public_path__ + "img/real-community.8907f314.jpeg";